module.exports = (__webpack_require__(0))(61);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FileModel.js from dll-reference girder_lib
// module id = 178
// module chunks = 0